import { PlusCircle } from "react-bootstrap-icons";
import { useArsListing } from "./ArsListingContextProvider";
import { ARSL_ADD_ROW } from "./interface";

/**
 * Renders a button to add a new row to the listing.
 * The button is only displayed if the listing is not disabled.
 * When clicked, it dispatches an action to add a new row with the last row's ID.
 *
 * @returns Add add button component
 */
export const ArsListingAddRowButton = <T,>(): React.ReactNode => {
  const { state, dispatch } = useArsListing<T>();
  if (!state || state.settings.disabled) return null;

  const lastRowId = state.bodyData.arsBodyRows[state.bodyData.arsBodyRows.length - 1].id;

  return (
    <div
      className="ars-listing-add-row-button"
      title="Add default row"
      role="button"
      tabIndex={0}
      onClick={() => {
        dispatch({
          operation: ARSL_ADD_ROW,
          rowId: lastRowId,
          type: "default",
        });
      }}
    >
      <PlusCircle aria-label="Add row" />
    </div>
  );
};

ArsListingAddRowButton.displayName = "ArsListingAddRowButton";
